/**
 * バリデーションエラーメッセージ定義
 */
export const VALIDATION_MESSAGES = {
  // 必須項目
  REQUIRED: '必須項目です',

  // プロフィール関連
  AGE_REQUIRED: '年齢は必須項目です',
  AGE_NUMERIC: '数値を入力してください',
  GENDER_REQUIRED: '性別を選択してください',
  AREA_REQUIRED: '居住エリアを選択してください',

  // 職歴・収入関連
  WORK_EXPERIENCE_REQUIRED: 'アルバイト経験を選択してください',
  ALLOWANCE_REQUIRED: 'お小遣いの金額を選択してください',
  MONEY_MANAGEMENT_REQUIRED: 'お金の管理方法を選択してください',

  // 質問項目
  Q1_REQUIRED: 'Q1の回答を選択してください',
  Q2_REQUIRED: 'Q2の回答を選択してください',
  Q3_REQUIRED: 'Q3の回答を選択してください',

  // 「その他」選択時
  OTHER_TEXT_REQUIRED: 'その他を選択した場合は内容を入力してください',
};

/**
 * エラーメッセージを取得する
 * @param {string} fieldName - フィールド名
 * @param {string} errorType - エラータイプ
 * @returns {string} エラーメッセージ
 */
export function getErrorMessage(fieldName, errorType) {
  const key = `${fieldName}_${errorType}`.toUpperCase();
  return VALIDATION_MESSAGES[key] || VALIDATION_MESSAGES.REQUIRED;
}
